import { render, staticRenderFns } from "./SignDoc.vue?vue&type=template&id=de43e350&scoped=true"
import script from "./SignDoc.vue?vue&type=script&lang=js"
export * from "./SignDoc.vue?vue&type=script&lang=js"
import style0 from "./SignDoc.vue?vue&type=style&index=0&id=de43e350&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de43e350",
  null
  
)

export default component.exports